import React, { useState } from 'react';
import { ClickAwayListener, Grow, Paper, Popper, MenuList } from '@mui/material';
import DrawerItem from './DrawerItem';

/**
 * A popup sub-menu component for the navigation drawer
 */
const NavDrawerMenu = ({ children, text, icon, drawerOpen, authLevel }) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = (event) => {
    if (anchorEl?.contains(event.target)) return;
    setOpen(false);
  };
  const handleToggle = (e) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
    setOpen(!open);
  };

  return (
    <DrawerItem
      action={handleToggle}
      text={text}
      icon={icon}
      isOpen={drawerOpen}
      authLevel={authLevel}
    >
      <Popper open={open} anchorEl={anchorEl} transition style={{ zIndex: 1300 }}>
        {({ TransitionProps }) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList className="nav nav-drawer-menu" onClick={handleClose}>
                  {children}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </DrawerItem>
  );
};

export default NavDrawerMenu;
